<template>
    <div>

        <div class="page_container" style="overflow-y: auto;overflow-x: hidden;">



            <div style="display: flex; align-items: center;">
                <div style="flex:1;">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane :label="$t('recharge.充电中车辆') + '(' + chargingList.length + ')'" name="first">
                        </el-tab-pane>
                        <el-tab-pane :label="$t('recharge.非充电车辆') + '(' + unChargingList.length + ')'" name="second">
                        </el-tab-pane>

                    </el-tabs>
                </div>
                <div> <el-form :inline="true" :size="size" style="flex:1;text-align: right;">

                        <el-form-item label-width="0">
                            <el-checkbox v-model="checked">{{ $t('public.autoRefresh') }}(15s)</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading="loading" @click="onSubmit">{{ $t('public.refresh')
                            }}</el-button>
                        </el-form-item>
                        <!-- <el-form-item>
                            <el-button type="success" @click="onOpenSetting">{{ $t('recharge.rechargeReminder')
                            }}</el-button>
                        </el-form-item> -->
                    </el-form></div>
            </div>
            <el-row v-if="activeName == 'first'" :gutter="20"
                style="max-height: calc(100vh - 200px); overflow-y: auto;">

                <kl-empty v-if="chargingList.length == 0" />
                <el-col :span="4" v-for="(item, n) in chargingList" :key="n">
                    <recharge_item :soc="(item.SOC && item.SOC != '') ? parseFloat(item.SOC) : 0" :carNo="item.carNo"
                        :isRecharge="true" :mileage="item.SurplusMileage" :totalVoltage="item.TotalVoltage"
                        :totalCurrent="item.TotalCurrent" :rechargeTime="item.ETFC" :VehicleID="item.VehicleID" :UpdateTime="item.UpdateTime" />
                </el-col>

            </el-row>
            <el-row v-if="activeName == 'second'" :gutter="20"
                style="max-height: calc(100vh - 200px); overflow-y: auto;display: block;position: relative;"
                @scroll="handleScroll($event)">
                <kl-empty v-if="unChargingList.length == 0" />
               
                <el-col :span="4" v-for="(item, n) in unChargingList" :key="n">
                    <recharge_item :soc="(item.SOC && item.SOC != '') ? parseFloat(item.SOC) : 0" :carNo="item.carNo"
                        :isRecharge="false" :mileage="item.SurplusMileage" :totalVoltage="item.TotalVoltage"
                        :totalCurrent="item.TotalCurrent" :rechargeTime="item.ETFC" :UpdateTime="item.UpdateTime" />
                </el-col>
                
                 <!-- <div class="bottom-highlight-tip" :class="{ 'highlight-active': isScrollToBottom }">
                    <i class="el-icon-warning"></i>
                    <span>已滚动到底部</span>
                </div> -->
            </el-row>

        </div>
        <el-dialog :visible.sync="dialogVisible" :title="$t('recharge.充电提醒设置')" width="500px">
            <el-divider></el-divider>
            <el-form label-width="140px" size="small">
                <el-form-item :label="$t('recharge.充电提醒设置')">
                    <div style="display: flex; align-items: center;">
                        <div> <el-radio-group v-model="MainFlag">
                                <el-radio :label="1">{{ $t('public.open') }}</el-radio>
                                <el-radio :label="0">{{ $t('public.close') }}</el-radio>
                            </el-radio-group></div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('recharge.选择车辆')">
                    <multi-select v-model="selectedMonitorVehicle" :options="vehicleMonitorOptions"
                        @change="handleVehicleChange" :show-all-option="true"></multi-select>
                </el-form-item>

                <el-form-item :label="$t('recharge.满电阈值(50-100)')">
                    <el-checkbox v-model="FullChargeFlag"></el-checkbox>
                    &nbsp;<el-input-number :disabled="!FullChargeFlag" v-model="FullChargeValue" :min="50"
                        :max="100"></el-input-number> <span style="color: #0F1A3A;">50-100%</span>
                </el-form-item>
                <el-form-item :label="$t('recharge.亏电阈值(0-50)')">
                    <el-checkbox v-model="LowChargeFlag"></el-checkbox>
                    &nbsp;<el-input-number :disabled="!LowChargeFlag" v-model="LowChargeValue" :min="0"
                        :max="50"></el-input-number> <span style="color: #0F1A3A;">0-50%</span>
                </el-form-item>
                <el-form-item v-if="false" :label="$t('recharge.邮箱地址')">
                    <el-input v-model="chargeSettings.email"></el-input>
                </el-form-item>
                <el-form-item :label="$t('recharge.通知接收人')">
                    <el-select v-model="selectedOperatorIds" multiple collapse-tags filterable
                        :placeholder="$t('recharge.请选择通知接收人')" style="width: 100%;">
                        <el-option v-for="item in operatorList" :key="item.OperatorID"
                            :label="item.OPTName + '(' + item.MobileTel + ')'" :value="item.OPT_ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-radio-group v-model="chargeSettings.notifyType">
                        <el-radio :label="1">{{ $t('recharge.短信提醒') }}</el-radio>
                        <el-radio :label="2">{{ $t('recharge.APP提醒') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer"><el-button @click="closeDialog">{{ $t('public.cancel')
                    }}</el-button>
                <el-button @click="saveSettings" type="primary">{{ $t('public.save') }}</el-button>

            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import settings from "@/settings";
import MultiSelect from './components/MultiSelect.vue'
import recharge_item from './components/recharge_item.vue'
export default {
    name: "chargemonitor",
    components: {
        recharge_item, MultiSelect
    },
    data() {
        return {
            isScrollToBottom: false,
            selectedMonitorVehicle: [],//选中的车辆
            MainFlag: 0,//是否开启
            FullChargeFlag: false,
            FullChargeValue: 0,
            LowChargeFlag: false,
            LowChargeValue: 0,
            selectedOperatorIds: [],//选中的通知接收人OperatorID数组
            operatorList: [],//通知接收人列表

            dialogVisible: false,
            chargeSettings: {
                notifyType: 1,
            },
           
            activeName: 'first',
            checked: false,
            progress: 60,
            form: {
                deviceNo: "",
                rechargestate: '-1',
                keys: '',
                vids: "",
                auto: false,
                PageNo: 1,
                PageSize: 100,
                OptID: 0,
            },
            total: 0,
            charge_options: [{
                value: '-1',
                label: this.$t('public.all')
            }, {
                value: '1',
                label: this.$t('recharge.charging')
            }, {
                value: '2',
                label: this.$t('recharge.uncharged')
            }],
            loading: false,
            tableData: [],
            timer: undefined,
            myVehicles: {},
        }
    },
    computed: {
        ...mapState({
            selectedVehicles: state => state.app.vehicles.selectedVehicles,
            appVehicles: state => state.app.vehicles,
        }),
        size() {
            return this.$store.getters.size
        },
        operator() {
            return this.$store.getters.operator
        },
        //充电中车辆
        chargingList() {
            return this.tableData.filter(item => item.Status == 1);
        },
        //未充电车辆
        unChargingList() {
            return this.tableData.filter(item => item.Status == 0);
        },
        vehicleMonitorOptions() {
            return this.$store.state.app.vehicles.data.filter(item => item.treeLevel == 5).map(item => {
                return {
                    value: item.mobile,
                    label: item.vehicleName
                }
            })

        }

    },
    destroyed() {

        if (this.timer)
            clearInterval(this.timer);


    },
    methods: {
        handleVehicleChange(values) {
            console.log('选中的终端:', values)
        },
        getOperatorList() {
            return this.$api.queryOperatorList({
                OperatorID: this.operator.OperatorId,
                OperatorName: '',
                PageNo: 1,
                PageSize: 65535
            }).then(res => {
                if (res && res.code == 200) {
                    this.operatorList = res.data.data || [];
                }
            })
        },

        queryChargeRemind() {
            return this.$api.queryLastChargeRemind({
                "RemindFlag": 1 //RemindFlag  1为多车 2为单车
            })
        },

        loadSettingsData() {
            Promise.all([this.getOperatorList(), this.queryChargeRemind()]).then(results => {
                const res = results[1];
                console.log(res);
                if (res && res.data) {
                    if (res.data.DeviceNos) {
                        this.selectedMonitorVehicle = res.data.DeviceNos.split(',')
                    }
                    else {
                        this.selectedMonitorVehicle = []
                    }
                    this.FullChargeFlag = res.data.FullChargeFlag == 1;
                    this.FullChargeValue = res.data.FullChargeValue;
                    this.LowChargeFlag = res.data.LowChargeFlag == 1;
                    this.LowChargeValue = res.data.LowChargeValue;
                    this.MainFlag = res.data.MainFlag;
                    // 将保存的手机号字符串转换为OperatorID数组
                    if (res.data.Mobile) {
                        const mobiles = res.data.Mobile.split(',');
                        this.selectedOperatorIds = this.operatorList
                            .filter(item => mobiles.includes(item.MobileTel))
                            .map(item => item.OPT_ID);
                    } else {
                        this.selectedOperatorIds = [];
                    }
                }
            })
        },

        saveSettings() {
            //通知接收人判断（无论是否开启提醒都必须选择）
            if (!this.selectedOperatorIds || this.selectedOperatorIds.length == 0) {
                this.$message.error(this.$t('recharge.请选择通知接收人'));
                return;
            }
            //开启时才需要判断车辆
            if (this.MainFlag == 1) {
                //判断是否有选中车辆
                if (this.selectedMonitorVehicle.length == 0) {
                    this.$message.error(this.$t('recharge.请选择车辆'));
                    return;
                }
            }

            // 将选中的OperatorID数组转换为手机号字符串（逗号分隔）
            const mobileStr = this.operatorList
                .filter(item => this.selectedOperatorIds.includes(item.OPT_ID))
                .map(item => item.MobileTel)
                .join(',');

            this.$api.setChargeRemind({
                "DeviceNos": this.selectedMonitorVehicle.join(','),
                "FullChargeFlag": this.FullChargeFlag ? 1 : 0,
                "FullChargeValue": this.FullChargeValue,
                "LowChargeFlag": this.LowChargeFlag ? 1 : 0,
                "LowChargeValue": this.LowChargeValue,
                "Mobile": mobileStr,
                "MainFlag": this.MainFlag,
                "RemindFlag": 1
            }).then(res => {
                if (res && res.code == 200) {
                    this.$message.success(this.$t('recharge.设置成功'));
                }

                this.closeDialog();
            })

            // 这里可以添加逻辑对输入数据进行验证，确保数据的有效性
        },
        onOpenSetting() {
            this.dialogVisible = true;
            this.loadSettingsData();
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        handleScroll(event) {
            const target = event.target;
            // 检查是否滚动到底部（考虑1像素的误差）
            this.isScrollToBottom = target.scrollHeight - target.scrollTop - target.clientHeight < 1;
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        init() {


            this.form.OptID = this.operator.OperatorId;


            if (this.timer != null)
                clearInterval(this.timer)

            if (this.timer == null) {
                setInterval(() => {
                    if (this.checked) {
                        this.queryList();
                    }
                }, 15 * 1000);
            }

        },

        getSelectedVehicles() {
            var vehicles = "";
            for (let k = 0; k < this.selectedVehicles.length; k++) {
                if (this.selectedVehicles[k].treeLevel == 5) {
                    vehicles = vehicles + this.selectedVehicles[k].mobile + ",";
                }
            }
            return vehicles.substring(0, vehicles.length - 1);
        },
        queryList() {
            this.loading = true;

            this.myVehicles = {};
            //获取选中的车辆，如果没有，用全部 vehicleName
            var vehicles = this.selectedVehicles;
            if (vehicles.length == 0)
                vehicles = this.appVehicles.data;

            vehicles.forEach(element => {
                this.myVehicles[element.mobile] = element;
            });

            var devices = [];
            // console.log(vehicles);

            devices = vehicles.filter(item => item.treeLevel == 5 && item.oilTypeID_New == 5).map(item => item.nodeValue);
            this.form.vids = devices.join(',');//改为车辆id

            this.$api.rechargelist(this.form).then(res => {
                this.loading = false;
                if (res && res.code == 200) {
                    this.tableData = res.data;
                    //找到对应的车牌
                    this.tableData.forEach(element => {
                        element.carNo = this.myVehicles[element.DeviceNo].vehicleName
                        element.manuID = this.myVehicles[element.DeviceNo].manuID

                    });

                    this.total = res.recordsTotal
                }

            }).catch(() => {
                this.loading = false;
            });
        },
        pageChange(page) {
            this.form.PageNo = page;
            this.queryList();
        },
        getIcon(row) {

            if (row.SOC == 100) {
                //已充满
                return "icon-icon_battery";
            }
            if (row.Status == 1) {
                //充电中
                if (row.SOC >= 50)
                    return "icon-icon_battery1";
                else if (row.SOC >= 20 && row.SOC < 50)
                    return "icon-icon_battery2";
                else {
                    return "icon-icon_battery6";
                }
            }
            if (row.Status == 0) {
                //未充电

                if (row.SOC >= 50)
                    return "icon-icon_battery3";
                else if (row.SOC >= 20 && row.SOC < 50)
                    return "icon-icon_battery4";
                else {
                    return "icon-icon_battery5";
                }
            }
            return "";
        },
        getColor(soc) {
            if (soc) {
                soc = parseFloat(soc);
                if (soc >= 50) return "#07B477";
                else if (soc >= 20 && soc < 50) return "#FBA31B";
                else return "#FF106E"
            }
            return "#FBA31B";
        },
        onSubmit() {

            this.form.PageNo = 1;

            this.queryList();
        }
    },
    mounted() {
          const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
        this.init();
        setTimeout(() => {
            this.onSubmit();
        }, 1000);

        // this.queryChargeRemind();

    }
}
</script>
<style lang="scss" scoped></style>
<style scoped>
.bottom-highlight-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px;
    text-align: center;
    background-color: #fff3cd;
    color: #856404;
    border-top: 1px solid #ffeaa7;
    display: none;
    z-index: 10;
}

.bottom-highlight-tip.highlight-active {
    display: block;
}

.bottom-highlight-tip i {
    margin-right: 5px;
}
</style>